﻿import React, { useContext, useCallback } from 'react';
import Context, { context_type } from '@Util/Context';
import { useTranslation } from 'react-i18next';
import { NavLink } from "react-router-dom";
import * as Api from '@Util/Api';
import { dashboard_pages, apiBase } from '@Util/GlobalValues';
import { User_Navigation_Props } from '@Util/Types';
import { write_console_error } from '@Util/Utils';
import {
    Icon_Person,
    Icon_Settings,
    Icon_Logout
} from '@Elements/ImageElements/Icons';

const User_Navigation: React.FC<User_Navigation_Props> = React.memo((props: User_Navigation_Props) => {
    const [t] = useTranslation();
    const {
        current_project,
        stop_time
    }: context_type = useContext(Context);

    const handleLogout = useCallback(async (e: React.MouseEvent<HTMLAnchorElement>): Promise<void> => {
        e.preventDefault();

        try {
            const confirmLogout = window.confirm(t('Text.ConfirmLogout'));

            if (confirmLogout) {
                localStorage.clear();
                sessionStorage.clear();

                if (current_project?.customerName) {
                    await stop_time(current_project.id.toString());
                }

                await Api.apiFetch(`${apiBase}/logout`);
                window.location.reload();
            }
        } catch (err) {
            write_console_error(err, err.message);
        }
    }, [current_project, stop_time, t]);

    return (
        <ul className="Dynamic_Island_User_Menu_List">
            <li className="Dynamic_Island_User_Menu_List_Item">
                <NavLink
                    to={dashboard_pages.profile}
                    end
                    className="Dynamic_Island_User_Menu_List_Item_PageLink"
                    title={t('Navigation.Profile')}
                    onClick={() => props.set_menu_is_active(false)}
                >
                    <Icon_Person />
                    {t('Navigation.Profile')}
                </NavLink>
            </li>
            <li className="Dynamic_Island_User_Menu_List_Item">
                <NavLink
                    to={dashboard_pages.settings}
                    end
                    className="Dynamic_Island_User_Menu_List_Item_PageLink"
                    title={t('Navigation.Settings')}
                    onClick={() => props.set_menu_is_active(false)}
                >
                    <Icon_Settings />
                    {t('Navigation.Settings')}
                </NavLink>
            </li>
            <li className="Dynamic_Island_User_Menu_List_Item">
                <a
                    href="#"
                    aria-label={t('Navigation.Logout')}
                    onClick={handleLogout}
                >
                    <Icon_Logout />
                    {t('Navigation.Logout')}
                </a>
            </li>
        </ul>
    );
});

export default User_Navigation;